interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "MVR";
};

const MVR: Currency = Object.freeze({
  "displayName": "Maldivian Rufiyaa",
  "numericCode": 462,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "MVR",
  "symbol": ".ރ"
});

export { MVR };
